import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.checklist');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-page-checklist',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.checklist/view.scss */
:host {
  display: block;
  height: 100vh;
  background-color: #F8F9FA;
}

.checklist-page {
  font-family: "Pretendard", sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.header-container {
  background-color: #FFFFFF;
  padding: 10px 20px;
  border-bottom: 1px solid #E3E3E3;
  z-index: 10;
  flex-shrink: 0;
}

.top-app-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.top-app-bar .nav-btn, .top-app-bar .action-btn {
  width: 44px;
  height: 44px;
  border-radius: 22px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #444746;
  cursor: pointer;
  flex-shrink: 0;
}
.top-app-bar .nav-btn:hover, .top-app-bar .action-btn:hover {
  background-color: #F1F3F4;
}
.top-app-bar .nav-btn:active, .top-app-bar .action-btn:active {
  background-color: #E3E3E3;
}
.top-app-bar .nav-btn i, .top-app-bar .action-btn i {
  font-size: 18px;
}

.header-main-row {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.filter-group {
  display: flex;
  gap: 6px;
  overflow-x: auto;
}
.filter-group::-webkit-scrollbar {
  display: none;
}
.filter-group .m3-chip {
  height: 34px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid #C4C7C5;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s;
}
.filter-group .m3-chip span {
  font-size: 13px;
  font-weight: 700;
  color: #444746;
}
.filter-group .m3-chip .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.filter-group .m3-chip .dot.ongoing {
  background-color: #1E8E3E;
}
.filter-group .m3-chip .dot.planned {
  background-color: #F9AB00;
}
.filter-group .m3-chip .dot.completed {
  background-color: #1A73E8;
}
.filter-group .m3-chip.active {
  background-color: #D3E3FD;
  border-color: #A8C7FA;
}
.filter-group .m3-chip.active span {
  color: #041E49;
}
.filter-group .m3-chip:hover:not(.active) {
  background-color: #F8F9FA;
  border-color: #A8C7FA;
}

.search-group {
  display: flex;
  align-items: center;
  background-color: #F1F3F4;
  height: 40px;
  border-radius: 20px;
  padding: 0 16px;
  gap: 10px;
  width: 100%;
  max-width: 280px;
  transition: all 0.2s;
  border: 1px solid transparent;
}
.search-group:focus-within {
  background-color: #FFFFFF;
  border-color: #0B57D0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.search-group .search-icon {
  color: #5F6368;
  font-size: 14px;
}
.search-group input {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-size: 14px;
  color: #1F1F1F;
  font-weight: 500;
}
.search-group input::placeholder {
  color: #70757A;
}

.scaffold-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 16px 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-shrink: 0;
}
.content-header .labels {
  display: flex;
  align-items: baseline;
  gap: 12px;
}
.content-header .title-large {
  font-size: 20px;
  font-weight: 800;
  color: #1F1F1F;
  margin: 0;
}
.content-header .body-small {
  font-size: 13px;
  color: #70757A;
  font-weight: 500;
}
.content-header .sort-box {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #0B57D0;
  font-size: 13px;
  font-weight: 700;
}
.content-header .sort-box select {
  border: none;
  background: transparent;
  color: inherit;
  font-family: inherit;
  font-weight: inherit;
  outline: none;
  cursor: pointer;
}

.project-list {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  min-height: 0;
  overflow-y: auto;
  align-content: start;
}

.m3-card {
  background-color: #FFFFFF;
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  border: 1px solid #E8EAED;
  transition: all 0.15s ease-out;
  overflow: hidden;
}
.m3-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border-color: #D3E3FD;
}
.m3-card:active {
  transform: scale(0.99);
}
.m3-card .status-bar {
  width: 5px;
  flex-shrink: 0;
  border-radius: 16px 0 0 16px;
}
.m3-card.ongoing .status-bar {
  background-color: #1E8E3E;
}
.m3-card.planned .status-bar {
  background-color: #F9AB00;
}
.m3-card.completed .status-bar {
  background-color: #1A73E8;
}

.card-body {
  flex: 1;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  min-width: 0;
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.card-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}
.card-title-row .title-medium {
  font-size: 16px;
  font-weight: 700;
  color: #1F1F1F;
  margin: 0;
  line-height: 1.3;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-badge {
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
  flex-shrink: 0;
}
.status-badge.ongoing {
  background-color: #E6F4EA;
  color: #137333;
}
.status-badge.planned {
  background-color: #FEF7E0;
  color: #B05E00;
}
.status-badge.completed {
  background-color: #E8F0FE;
  color: #1967D2;
}

.card-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.card-info .info-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #5F6368;
}
.card-info .info-item i {
  width: 14px;
  font-size: 12px;
  color: #9AA0A6;
  text-align: center;
}

.card-action {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #0B57D0;
  font-size: 13px;
  font-weight: 700;
}
.card-action i {
  font-size: 11px;
}

.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 14px 0 6px;
  flex-shrink: 0;
}

.page-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid #E0E0E0;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #1F1F1F;
  transition: all 0.15s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.page-btn i {
  font-size: 16px;
}
.page-btn:hover:not(:disabled) {
  background-color: #E8F0FE;
  border-color: #0B57D0;
  color: #0B57D0;
}
.page-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.page-indicators {
  display: flex;
  gap: 8px;
}

.page-dot {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #5F6368;
  cursor: pointer;
}
.page-dot:hover {
  background-color: #F1F3F4;
}
.page-dot.active {
  background-color: #0B57D0;
  color: #FFFFFF;
}

.loader-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.loader-container p {
  margin-top: 16px;
  font-size: 14px;
  color: #5F6368;
  font-weight: 600;
}

.google-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #E8EAED;
  border-top-color: #0B57D0;
  border-radius: 50%;
  animation: spin 0.9s ease-in-out infinite;
}

.empty-view {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.empty-view .empty-icon {
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
  background: #F1F3F4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.empty-view .empty-icon i {
  font-size: 32px;
  color: #9AA0A6;
}
.empty-view h3 {
  font-size: 18px;
  color: #3C4043;
  font-weight: 700;
  margin: 0 0 6px;
}
.empty-view p {
  font-size: 13px;
  color: #5F6368;
  margin: 0;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}`],
})
export class PageChecklistComponent implements OnInit {
    public projects: any[] = [];
    public displayProjects: any[] = [];
    public loading: boolean = true;

    public filterTab: string = 'all';
    public searchText: string = '';
    public sortType: string = 'latest';

    public pageSize: number = 4;
    public currentPage: number = 1;

    constructor(@Inject( Service)         public service: Service,@Inject( CDR    )         public ref: CDR    ) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.loadProjects();
    }

    public async loadProjects() {
        this.loading = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call("init");
            if (code === 200) {
                this.projects = data.projects || [];
                this.onFilter();
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public setFilter(tab: string) {
        this.filterTab = tab;
        this.currentPage = 1;
        this.onFilter();
    }

    public onFilter() {
        let filtered = [...this.projects];

        if (this.filterTab !== 'all') {
            filtered = filtered.filter(p => p.status_color === this.filterTab);
        }

        if (this.searchText) {
            const query = this.searchText.toLowerCase().trim();
            filtered = filtered.filter(p =>
                p.title.toLowerCase().includes(query) ||
                (p.client && p.client.toLowerCase().includes(query))
            );
        }

        filtered.sort((a, b) => {
            if (this.sortType === 'title') return a.title.localeCompare(b.title);
            if (this.sortType === 'latest') return (b.created || '') > (a.created || '') ? 1 : -1;
            return 0;
        });

        this.displayProjects = filtered;
        this.currentPage = 1;
        this.service.render();
    }

    public get totalPages(): number {
        return Math.max(1, Math.ceil(this.displayProjects.length / this.pageSize));
    }

    public get paginatedProjects(): any[] {
        const start = (this.currentPage - 1) * this.pageSize;
        return this.displayProjects.slice(start, start + this.pageSize);
    }

    public get pageStart(): number {
        if (this.displayProjects.length === 0) return 0;
        return (this.currentPage - 1) * this.pageSize + 1;
    }

    public get pageEnd(): number {
        return Math.min(this.currentPage * this.pageSize, this.displayProjects.length);
    }

    public nextPage() {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.service.render();
        }
    }

    public prevPage() {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.service.render();
        }
    }

    public get pageNumbers(): number[] {
        const pages: number[] = [];
        for (let i = 1; i <= this.totalPages; i++) {
            pages.push(i);
        }
        return pages;
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        return dateStr.split(' ')[0];
    }

    public getStatusLabel(color: string): string {
        if (color === 'ongoing') return '진행중';
        if (color === 'planned') return '예정';
        if (color === 'completed') return '완료';
        return '';
    }

    public async selectProject(project: any) {
        await this.service.href(`/checklist/project/${project.id}`);
    }

    public async goBack() {
        await this.service.href('/home');
    }
}

export default PageChecklistComponent;